import { Component, OnInit, ChangeDetectorRef, inject} from '@angular/core';
import { ParametrosService } from '../../../../services/parametros.service';
import { Subgrupo } from '../../../../models/parametros.model';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ErrorModel } from '../../../../models/error.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-subgrupo',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './subgrupo.component.html',
  styleUrls: ['./subgrupo.component.css']
})
export class SubgrupoComponent implements OnInit {
  subgrupos: Subgrupo[] = [];
  filteredSubgrupos: Subgrupo[] = [];
  paginatedSubgrupos: Subgrupo[] = [];
  
  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 1;
  maxPagesToShow = 5;
  startPage!: number;
  endPage!: number;
  pages: number[] = [];

  searchTerm = '';

  constructor(private parametrosService: ParametrosService, private router: Router,
    private toastr: ToastrService
  ) { }
  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.loadSubgrupos();
  } 

  loadSubgrupos(): void {
   this.parametrosService.getSubgrupos().subscribe(data => {
      this.subgrupos = data;
      this.filteredSubgrupos = data;
      this.totalPages = Math.max(1, Math.ceil(this.filteredSubgrupos.length / this.itemsPerPage));
      this.setPage(1);
      this.cdr.detectChanges();
    });
  }

  search(): void {
    this.filteredSubgrupos = this.subgrupos.filter(subgrupo =>
      subgrupo.nome.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
    this.totalPages = Math.max(1, Math.ceil(this.filteredSubgrupos.length / this.itemsPerPage));
    this.setPage(1);
  }

  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    this.currentPage = page;
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = Math.min(startIndex + this.itemsPerPage, this.filteredSubgrupos.length);
    this.paginatedSubgrupos = this.filteredSubgrupos.slice(startIndex, endIndex);
    this.updatePageNumbers();
  }

  updatePageNumbers(): void {
    const halfPages = Math.floor(this.maxPagesToShow / 2);
    this.startPage = Math.max(1, this.currentPage - halfPages);
    this.endPage = Math.min(this.totalPages, this.startPage + this.maxPagesToShow - 1);

    if (this.endPage - this.startPage + 1 < this.maxPagesToShow) {
      this.startPage = Math.max(1, this.endPage - this.maxPagesToShow + 1);
    }

    this.pages = Array.from(
      { length: (this.endPage - this.startPage) + 1 },
      (_, i) => this.startPage + i
    );
  }

  novoSubgrupo(): void {
    this.router.navigate(['/home', 'parametro-despesa-subgrupo-manutencao']);
    
  }

  editarSubgrupo(id: number): void {
    this.router.navigate(['/home', 'parametro-despesa-subgrupo-manutencao', id]);
  }

  deleteSubgrupo(id: number): void {
    this.parametrosService.deleteSubgrupo(id).subscribe({
          next: () => {
            this.loadSubgrupos();
            this.toastr.success('Subgrupo excluído com sucesso!');
          },
          error: (error) => {
            var erro: ErrorModel = error.error;
            this.toastr.error(erro.message);
          }});
  }


}
